module.exports = __webpack_public_path__ + "img/page2-1.74170448.png";